import { Trans, useTranslation } from "react-i18next"

const Footer = () => {
  const {t} = useTranslation('translation',{keyPrefix: 'layout.footer'})

    return (
      <footer id="footer" className="footer">
        <div className="copyright">
          &copy; Copyright{" "}
          <strong>
            <span>IICA</span>
          </strong>
          .
        </div>
        <div className="credits">
          <Trans i18nKey="layout.footer.descripcion">
            Visite nuestra página web <a href="https://iica.int/">IICA.INT</a>
          </Trans>

          {/* Visite nuestra página web <a href="https://iica.int/">IICA.INT</a> */}
        </div>
      </footer>
    );
}

export default Footer